import { render } from "./shift-scheduling-filter.vue?vue&type=template&id=3894ae5e"
import script from "./shift-scheduling-filter.vue?vue&type=script&lang=js"
export * from "./shift-scheduling-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__